import { useMutation } from 'react-query';
import { BillingApi } from 'app/modules/settings/modules/billing/api/billing';
import { StripeSetupIntentResponse } from 'app/modules/settings/modules/billing/types';

export type CreateStripeSetupIntentVars = {
  idempotencyKey: string;
};

/**
 * Imperative mutation for `POST /billing/stripe/setup-intent`. Not modeled as
 * `useQuery` because the clientSecret is one-shot and the request body is
 * empty — callers fire it on modal-open and pass the result into the
 * `<Elements>` provider.
 */
export const useStripeSetupIntent = () =>
  useMutation<StripeSetupIntentResponse, unknown, CreateStripeSetupIntentVars>(
    ({ idempotencyKey }) => BillingApi.createStripeSetupIntent(idempotencyKey),
  );
